var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDirectHire(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3771 19.0001H5.62287C3.07401 19.0001 1 17.0854 1 14.7315V10.027C1 7.67302 3.07401 5.7583 5.62287 5.7583H14.3771C16.926 5.7583 19 7.67302 19 10.027V14.7315C19 17.0854 16.926 19.0001 14.3771 19.0001Z",
    fill: "#0083FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3006 2.21825C8.01411 2.21825 6.16056 3.99089 6.16056 6.17755V8.71557C6.16056 9.05198 5.8754 9.32469 5.52364 9.32469C5.17188 9.32469 4.88672 9.05198 4.88672 8.71557V6.17755C4.88672 3.31807 7.31058 1 10.3006 1C13.2905 1 15.7144 3.31807 15.7144 6.17755V8.71557C15.7144 9.05198 15.4293 9.32469 15.0775 9.32469C14.7257 9.32469 14.4406 9.05198 14.4406 8.71557V6.17755C14.4406 3.99089 12.587 2.21825 10.3006 2.21825Z",
    fill: "#0083FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectHire);
export default __webpack_public_path__ + "static/media/directHire.d093241d.svg";
export { ForwardRef as ReactComponent };